import { render, staticRenderFns } from "./ParticaTitle.vue?vue&type=template&id=4623e3a3&"
import script from "./ParticaTitle.vue?vue&type=script&lang=ts&"
export * from "./ParticaTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports